import React from "react";
import { WithModal } from "ctia-ui";
import EditLabModal from "containers/ControlPanel/Orgs/Labs/EditLabModal";

class EditLab extends WithModal {
  render() {
    const { id, name } = this.props;

    return (
      <div className="glow-link cursor-pointer">
        <span onClick={this.handleModal}>{name}</span>
        {this.state.showModal && (
          <EditLabModal
            id={id}
            modalHandler={this.handleModal}
          />
        )}
      </div>
    );
  }
}

export default EditLab;
